import { render, staticRenderFns } from "./IncludedBadge.vue?vue&type=template&id=fd92a336&"
import script from "./IncludedBadge.vue?vue&type=script&setup=true&lang=ts&"
export * from "./IncludedBadge.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports